'use strict';

var BiLoggerClientFactory = require('./bi-logger-factory');
var BiLogger = require('./bi-logger');

module.exports.BiLoggerFactory = BiLoggerClientFactory;
module.exports.BiLogger = BiLogger;

module.exports.factory = function () {
  return new BiLoggerClientFactory();
};
//# sourceMappingURL=index.js.map